<template>
  <div class="apply-info-card">
    <div class="sign-intro">
      <img :src="headUrl" class="intro-img" />
      <div class="intro-info">
        <div
          class="intro-item-hd"
          v-for="(item, index) in baseInfo"
          :key="index"
        >
          <div class="intro-item" v-for="(_item, _index) in item" :key="_index">
            <div class="intro-item-label">{{ _item.label }}<span></span></div>
            <div class="intro-item-value">：{{ _item.value }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="line"></div>
</template>
<script>
import { reactive, toRefs, computed, watch } from "vue";
import { getApplyUserInfo } from "@/api/api";
import { message } from "ant-design-vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { getOpenEditDetail } from "@/api/openapply";
import {
  borrowApplyDetail,
  financialApplyDetail,
  siteSelectionDetail,
  houseRentDetail,
  decproDetail,
} from "@/api/process";
import { detail } from "@/api/process_open";
import { getEmployeeTransferApply } from "@/api/process_employeeTransfer";
import { getBusinessApplyFirstInfo } from "@/api/process_employeeTransfer";
import {
  getBankAccountRegistration,
  getBankAccountApply,
  getTaxReporting,
} from "@/api/process_bank";
import { checkNameDetail } from "@/api/process_company";
import {
  getBusinessFilingsInfo,
  getBusinessApplySecondInfo,
  getBusinessApplyThirdInfo,
} from "@/api/process_bussiness";
export default {
  props: {
    ApplicationTime: {
      type: String,
      default: "",
    },
    folwId: {
      type: Number,
      default: 0,
    },
    ApplicationInfo: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  setup(props) {
    const store = useStore();
    const personInfo = computed(() => store.getters.getSimpleInfo);
    const route = useRoute();
    const { id, type } = route.query;
    watch(
      () => props.ApplicationInfo,
      () => {
        setInfo();
      }
    );
    const data = reactive({
      Spinning: false,
      headUrl: "",
      baseInfo: [],
    });

    const setInfo = () => {
      let Data = props;
      data.baseInfo = [
        [
          { label: "申请人姓名", value: Data?.ApplicationInfo.StaffName },
          { label: "直属上级", value: Data?.ApplicationInfo.LeaderName },
        ],
        [
          { label: "归属公司", value: Data?.ApplicationInfo.CompanyName },
          { label: "岗位类型", value: Data?.ApplicationInfo.PostType },
        ],
        [{ label: "所属部门", value: Data?.ApplicationInfo.DepartmentName }],
        [{ label: "岗 位", value: Data?.ApplicationInfo.PositionName }],
      ];
      data.headUrl = Data?.ApplicationInfo.PhotoUrl;
      if (Data.ApplicationTime) {
        data.baseInfo[2].push({
          label: "申请时间",
          value: Data.ApplicationTime,
        });
      }
    };

    return {
      ...toRefs(data),
      getApplyUserInfo,
    };
  },
};
</script>

<style scoped lang="less">
.apply-info-card {
  padding: 0px 0px 24px 0px;
  height: 104px;
  .sign-intro {
    display: flex;
    align-items: center;
    margin: 20px 0;
    margin-bottom: 24px;
    .intro-img {
      margin-left: 10px;
      display: block;
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }
    .intro-info {
      display: flex;
      flex: 1;
    }
    .intro-item-hd {
      padding: 17px 0px 17px 30px;
      height: 80px;
      margin-right: 30px;
    }
    .intro-item {
      display: flex;
      align-items: baseline;
      height: 16px;
      line-height: 16px;
    }
    .intro-item:nth-child(2) {
      margin-top: 14px;
    }
    .intro-item-label {
      min-width: 60px;
      font-size: 14px;
      line-height: 16px;
      color: #666666;
      text-align: justify;
      text-align-last: justify;
      span {
        display: inline-block;
        width: 100%;
      }
    }
  }
  .line {
    width: 100%;
    border-top: 1px solid #eee;
    margin: 20px 0px;
  }
}
</style>


